/**
 * "Clear Canvas" (header trash icon) — reset the graph, keep the case.
 *
 * Tender sheet #43. Clear Canvas used to call the same full reset as "New
 * Investigation": it dropped case_id / investigation_id from the URL, the
 * session subject, the Omnibar text and the backend session, so an officer
 * who only wanted an empty canvas lost the case they were working in.
 *
 * This resets the GRAPH only: elements, selection, graph filters, the stash,
 * the per-node transaction data that hangs off the removed nodes, and the
 * pending-layout counter. Undo history is kept so Undo brings the canvas back
 * (the caller pushes a snapshot first).
 *
 * Deliberately NOT touched: useWorkbenchSessionStore (session chain/address,
 * case/investigation ids, Omnibar text), the URL, the investigation results,
 * and the backend session. "New Investigation" still does the full reset
 * (`resetWorkbenchToFresh` in Workbench.tsx).
 */
import { useGraphStore } from '../stores/useGraphStore';
import { useStashStore } from '../stores/useStashStore';
import { useTransactionStore } from '../stores/useTransactionStore';
import { useSelectionStore } from '../stores/useSelectionStore';
import { useFilterStore } from '../stores/useFilterStore';
import { usePendingLayoutStore } from '../stores/usePendingLayoutStore';
import { beginControlledWrite, endControlledWrite } from '../services/canvasControlledWrite';

export function clearWorkbenchCanvasOnly(): void {
    beginControlledWrite();
    try { useGraphStore.getState().setElements([]); } finally { endControlledWrite(); }
    useStashStore.getState().clearAll();
    useSelectionStore.getState().clearSelection();
    useTransactionStore.getState().clearAll();
    useFilterStore.getState().resetFilters();
    usePendingLayoutStore.getState().clear();
}
